<template>
  <div class=" my-auto">
     <section class="background mx-auto">
      <h4 class=" text-center">Advice {{"#" + Id}}</h4>
      <p class="text-white text-center mt-5"> {{Quote}}</p><br>
        <hr class="text-white">
        <h1 class="text-white text-center linep">""</h1>
        <div class="text-center mx-auto">
          <button id="text" class="btn btn-md text-white" @click="getQuote"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M20 0H4a4.005 4.005 0 0 0-4 4v16a4.005 4.005 0 0 0 4 4h16a4.005 4.005 0 0 0 4-4V4a4.005 4.005 0 0 0-4-4ZM7.5 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0-9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0-9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" fill="hsl(150, 100%, 66%)"/></svg></button>
          
        </div>
     </section>
      <br><br><br>
      <div class="attribution text-white">
    Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. 
    Coded by <a href="https://www.linkedin.com/in/michael-olowe-7b600620a">Maiqel</a>.
  
  </div>
  </div>
</template>


<script>
  export default {
    name: 'Content',
    data() {
      return {
        Quote: "",
        Id : "",
      } 
    },
    methods: {
      async getQuote() {
        const res = await fetch('https://api.adviceslip.com/advice')
        const data = await res.json()
        // console.log(data);

        this.Quote= data["slip"]["advice"]
        this.Id = data.slip.id
      }
    },
    created() {
      this.getQuote()
    },
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Manrope&display=swap');
  *{
    font-family: Manrope;
  }

  section{
    height: 100%;
    width: 320px;
    max-width: 100%;
    margin-top: 210px;
    border-radius: 15px;
    background-color: hsl(218,20%,24%);
}

h4{
  color: hsl(150, 100%, 66%)
}
button{
  margin-bottom: -20px;
}

.linep{
  margin-top: -28px;
}


.attribution { font-size: 16px; text-align: center; }
    .attribution a { color: hsl(228, 45%, 44%); }
</style>